var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.82 30H10.18A5 5 0 0 1 5 25.24V19a1 1 0 0 1 2 0v6.24A3 3 0 0 0 10.18 28h11.64A3 3 0 0 0 25 25.24V19a1 1 0 0 1 2 0v6.24A5 5 0 0 1 21.82 30zm7.89-13.29a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0-1.42 0l-13 13a1 1 0 0 0 1.42 1.42L16 4.41l12.29 12.3a1 1 0 0 0 1.42 0z",
    "data-name": "9-Home",
    fill: "#5e7894",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeA);
export default __webpack_public_path__ + "static/media/home-A.c29875ddfe787a2922bf66841ed5f205.svg";
export { ForwardRef as ReactComponent };